import { Favorite, FavoriteBorder } from '@material-ui/icons'
import TextField from 'components/common/TextField'
import styled from 'styled-components'
import { resetButton } from 'styles/mixins'
import TypographyPro from 'themes/TypographyPro'

export const StyledSaveAddressSectionContainer = styled.div<{ height: string }>`
	width: 100%;
	height: ${({ height }) => height};
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
	transition: height 0.125s ease-in-out;
`

export const StyledSaveAddressCtaContainer = styled.button`
	${resetButton}
	margin-top: 0.5rem;
	display: flex;
	gap: 0.75rem;
	align-items: center;
`

export const StyledSaveAddressLabelsContainer = styled.div<{ show: boolean }>`
	width: 100%;
	display: flex;
	gap: 0.75rem;
	transition: all 0.125s ease-in-out;

	${({ show }) =>
		show
			? `
      display: block
      opacity: 1;
      transform: translateY(0);
    `
			: `
      display: none;
      opacity: 0;
      transform: translateY(-2rem);
      `}
`

export const StyledSaveAddressCustomLabelContainer = styled.div<{ show: boolean }>`
	transition: all 0.125s ease-in-out;
	${({ show }) =>
		show
			? `
      display: block;
      opacity: 1;
      transform: translateY(0);
    `
			: `
      display: none;
      opacity: 0;
      transform: translateY(-1rem);
      `}
`

export const StyledSaveAddressCustomLabelTitle = styled(TypographyPro)`
	color: var(--fonts);
	padding-bottom: 0.25rem;
`

export const StyledSaveAddressCustomLabelInput = styled(TextField)<{ selected: boolean }>`
	& .MuiOutlinedInput-notchedOutline {
		border: 1px solid ${({ selected }) => (selected ? 'var(--inactive)' : 'var(--disable)')};
	}
`

export const StyledSaveAddressHeartContainer = styled.div`
	position: relative;
	width: 1.5rem;
	height: 1.5rem;
`

const heartIconStyle = (show: boolean) => `
  position: absolute;
  left: 0;
  top: 0;
  width: 1.5rem;
  height: 1.5rem;
  opacity: ${show ? '1' : '0'};
  transition: opacity 0.125s ease-in-out;
  color: var(--primary);
`

export const StyledSaveAddressHeartIcon = styled(Favorite)<{ $show: boolean }>`
	${({ $show }) => heartIconStyle($show)}
`

export const StyledSaveAddressHeartOutlineIcon = styled(FavoriteBorder)<{ $show: boolean }>`
	${({ $show }) => heartIconStyle($show)}
`

export const StyledSaveAddressText = styled(TypographyPro)`
	color: var(--fonts);
`
